module.exports = __webpack_public_path__ + "media/images/icons/club_bi-6780c1466221865a632317db4dbde4ab.svg";